import { Stack, Typography } from "@mui/material";
import { DashboardTile } from "components/Dashboard/DashboardTile";
import { FacilitiesByGeneratorStatusChart } from "./Charts/FacilitiesByGeneratorStatusChart";
import { FacilitiesByLocationAndGeneratorStatusChart } from "./Charts/FacilitiesByLocationAndGeneratorStatusChart";
import { useWasteOverviewState } from "../WasteOverviewContext";

export function FacilitiesByGeneratorStatusTile() {
  const {
    overviewState: { isPending },
  } = useWasteOverviewState();

  return (
    <DashboardTile size={12} spacing={3}>
      <DashboardTile.ContentArea
        direction={{ xs: "column", lg: "row" }}
        spacing={2}
        sx={{ flexGrow: 1, opacity: isPending ? 0.5 : 1 }}
      >
        <Stack sx={{ flex: 1 }}>
          <DashboardTile.Header
            title="Facilities by Current Generator Status"
            infoTooltip={<FacilitiesByGeneratorStatusTooltip />}
          />

          <FacilitiesByGeneratorStatusChart />
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <DashboardTile.Header
            title="Facilities by Location and Current Generator Status"
            infoTooltip={
              <Typography variant="caption">
                This displays waste facilities broken down by state and current
                reported generator status (via RCRAInfo), sorted by highest
                facility count. Use the arrows at the bottom to click through to
                see waste facility counts and generator status breakdowns in all
                states.
              </Typography>
            }
          />

          <FacilitiesByLocationAndGeneratorStatusChart />
        </Stack>
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
}

const FacilitiesByGeneratorStatusTooltip = () => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="caption">
        Facility Generator status displays the current reported generator
        statuses (via RCRAInfo) of your waste facilities. Click on any segment
        of the chart to filter the graph on the right.
      </Typography>
      <Typography variant="caption">
        <Typography component="span" variant="caption" fontStyle="italic">
          Very Small Quantity Generaton
        </Typography>{" "}
        (VSQG) Generated 220 lbs or less of hazardous waste per month [or combo
        of hazardous + acutely hazardous] or generated less than 2.2 lbs of
        acutely hazardous waste per month
      </Typography>
      <Typography variant="caption">
        <Typography component="span" variant="caption" fontStyle="italic">
          Small Quantity Generator (SQG)
        </Typography>{" "}
        Generated more than 220 lbs and less than 2,200 lbs of hazardous waste
        per month [or combo of hazardous + acutely hazardous] or generated less
        than 2.2 lbs of acutely hazardous waste per month
      </Typography>
      <Typography variant="caption">
        <Typography component="span" variant="caption" fontStyle="italic">
          Large Quantity Generator (LQG)
        </Typography>{" "}
        Generated more than 2,200 lbs of hazardous waste per month [or combo of
        hazardous + acutely hazardous] or generated more than 2.2 lbs of acutely
        hazardous waste per month
      </Typography>
      <Typography variant="caption">
        <Typography component="span" variant="caption" fontStyle="italic">
          None
        </Typography>{" "}
        Does not have a current reported generator status in RCRAInfo.
      </Typography>
    </Stack>
  );
};
